// Les options qui seront proposées à l'utilisateur dans le menu déroulant
import { i18n } from '@/plugins/i18n'

export const ROWS_PER_PAGE_ITEMS = [
  { value: 5, label: i18n.t('5') },
  { value: 10, label: i18n.t('10') },
  { value: 15, label: i18n.t('15') },
  { value: 20, label: i18n.t('20') },
  { value: 25, label: i18n.t('25') },
  { value: 50, label: i18n.t('50') },
  { value: 100, label: i18n.t('100') },
  { value: 300, label: i18n.t('300') },
  { value: 500, label: i18n.t('500') },
  { value: -1, label: i18n.t('Tous') },
]

export const DEFAULT_ROWS_PER_PAGE = 25

export const LOCAL_STORAGE_KEY = 'user_default_rows_per_page'
